module.exports = "<loader loaderName=\"auth\"></loader>\n\n<header class=\"auth\">\n    <img src=\"/assets/images/cms-logo.png\" />\n</header>\n\n<router-outlet></router-outlet>\n\n<div class=\"clearfix\"></div>\n<footer>\n    <img src=\"/assets/images/signature.png\" />© 2018 Vitkac Mailing. All rights reserved.\n</footer>"


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/auth/auth.component.html
// module id = ../../../../../src/app/auth/auth.component.html
// module chunks = 1